module.exports = __webpack_public_path__ + "img/exercise_test-6.a89f0153.png";